import { createAction } from 'redux-actions';

export const onChangeQuery = createAction('RO_PICKLIST_ON_CHANGE_QUERY');

export const onClearQuery = createAction('RO_PICKLIST_ON_CLEAR_QUERY');
